import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import Menu from './components/Menu';
import Cart from './components/Cart';
import MenuDisplay from './components/MenuDisplay';
import CartSummaryPage from './pages/CartSummaryPage';
import { CartContext } from './context/CartContext';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
// import Badge from '@mui/material/Badge';
import Skeleton from '@mui/material/Skeleton';
import BanHeader from './components/BanHeader';
import DashboardCommandes from './pages/DashboardCommandes'; // en haut
import DashboardPlats from './pages/DashboardPlats';
import DashboardMenus from './pages/DashboardMenus';
import DashboardCategories from './pages/DashboardCategories';
import DashboardReglages from './pages/DashboardReglages';
import Footer from './components/Footer';
import './App.css'; // Assurez-vous de créer ce fichier CSS pour le style
import './responsive.css'; // Importez le fichier CSS pour la responsivité
import './styles/responsive.css';
import Home from './components/Home';
import NotreCartePage from './components/NotreCartePage';
import OrderButton from './components/OrderButton';
import Diaporama from './components/Diaporama';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const App = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [categories, setCategories] = useState({});

  // Charger les catégories une seule fois pour le Cart global
  useEffect(() => {
    fetch(`/assets/json/carte.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        setCategories(data.categories);
      })
      .catch(() => {});
  }, []);

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  // Ajout pour le prompt d'installation PWA personnalisé
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [infosGenerales, setInfosGenerales] = useState(null);

  useEffect(() => {
    // Charger les infos générales
    fetch(`/assets/json/infos-generale.json?v=${Date.now()}`)
      .then(res => res.json())
      .then(data => setInfosGenerales(data))
      .catch(() => setInfosGenerales(null));
  }, []);

  useEffect(() => {
    // Ne pas afficher le prompt si refusé récemment
    const refused = localStorage.getItem('pwaInstallRefusedAt');
    if (refused) {
      const refusedDate = new Date(parseInt(refused, 10));
      const now = new Date();
      const diffDays = (now - refusedDate) / (1000 * 60 * 60 * 24);
      if (diffDays < 5) {
        setShowInstallPrompt(false);
        return;
      }
    }
    const handler = (e) => {
      // Vérifie à nouveau ici pour éviter l'affichage si refusé
      const refused = localStorage.getItem('pwaInstallRefusedAt');
      if (refused) {
        const refusedDate = new Date(parseInt(refused, 10));
        const now = new Date();
        const diffDays = (now - refusedDate) / (1000 * 60 * 60 * 24);
        if (diffDays < 5) {
          return;
        }
      }
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPrompt(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  // Ajout pour gérer le refus temporaire du prompt d'installation
  useEffect(() => {
    const refused = localStorage.getItem('pwaInstallRefusedAt');
    if (refused) {
      const refusedDate = new Date(parseInt(refused, 10));
      const now = new Date();
      const diffDays = (now - refusedDate) / (1000 * 60 * 60 * 24);
      if (diffDays < 15) {
        setShowInstallPrompt(false);
        return;
      } else {
        localStorage.removeItem('pwaInstallRefusedAt');
      }
    }
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setShowInstallPrompt(false);
      setDeferredPrompt(null);
    }
  };

  const handleRefuseInstall = () => {
    localStorage.setItem('pwaInstallRefusedAt', Date.now().toString());
    setShowInstallPrompt(false);
  };

  return (
    <Router>
      {/* Prompt d'installation PWA personnalisé */}
      {showInstallPrompt && infosGenerales && (
        <div style={{
          position: 'fixed',
          bottom: 24,
          left: 0,
          right: 0,
          zIndex: 2000,
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{
            background: '#fff',
            border: '1px solid #eee',
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            padding: 16,
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            maxWidth: 400,
            width: '90%',
            display: 'flex', flexDirection: 'column'
          }}>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', gap: 12 }}>
              {infosGenerales.logoResto && (
                <img src={infosGenerales.logoResto} alt="logo" style={{ width: 100, height: 100, borderRadius: 8 }} />
              )}
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 10 }}>
                <div style={{ fontWeight: 600, fontSize: 18 }}>
                  Ajouter l'app {infosGenerales.nomSite || infosGenerales.nom || 'cette application'} à votre mobile
                </div>
                <div style={{ fontSize: 14, color: '#666', marginTop: 4 }}>
                  Accès rapide à votre resto préféré.
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button className='addPwa' onClick={handleInstallClick}>Installer l'app</button>
                  <button
                    className='refusePwa'
                    onClick={handleRefuseInstall}
                    style={{
                      background: '#eee',
                      color: '#333',
                      border: 'none',
                      borderRadius: 6,
                      padding: '8px 14px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    Non merci
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <BanHeader toggleCart={toggleCart} isCartOpen={isCartOpen} />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              toggleCart={toggleCart}
              isCartOpen={isCartOpen}
              setIsCartOpen={setIsCartOpen}
            />
          }
        />
        <Route path="/cart-summary" element={<CartSummaryPage />} />
        <Route path="/dashboard" element={<DashboardCommandes />} />
        <Route path="/dashboard/plats" element={<DashboardPlats />} />
        <Route path="/dashboard/menus" element={<DashboardMenus />} />
        <Route path="/dashboard/categories" element={<DashboardCategories />} />
        <Route path="/dashboard/reglages" element={<DashboardReglages />} />
        <Route path="/notre-carte-a-emporter" element={<NotreCartePage />} />
      </Routes>
      <Cart categories={categories} isOpen={isCartOpen} setIsOpen={setIsCartOpen} />
      <Footer />
    </Router>
  );
};

export default App;
